import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How long does it take to develop a retail app?",
    answer: `<p>Development timelines vary, but a typical retail app can take 3-6 months depending on complexity, features, and integrations.</p>`,
  },
  {
    question: "What platforms do you develop retail apps for?",
    answer: ` <p>We develop native apps for iOS and Android, as well as cross-platform apps that work seamlessly on both.</p>`,
  },
  {
    question:
      "Can my retail app be integrated with existing systems like POS and CRM?",
    answer: `<p>Yes, we specialize in integrating retail apps with existing systems such as POS, CRM, ERP, and payment gateways for seamless operations.</p>`,
  },
  {
    question: "How do you ensure the security of payment and customer data?",
    answer: `<p>We use PCI-compliant payment systems, encryption, and secure APIs to protect customer data and ensure secure transactions.</p>`,
  },
  {
    question: "Will the app be scalable as my business grows?",
    answer: ` <p>Absolutely. We build apps with scalability in mind, allowing you to add features and handle increased traffic as your business expands.</p>`,
  },
  {
    question: "Do you provide post-launch support and updates?",
    answer: ` <p>Yes, we offer ongoing support, maintenance, and updates to ensure your retail app stays up-to-date and performs optimally.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>
                <span>Retail App</span> Development FAQs
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
